import React from "react";
import { SmsComponent } from "./sms";
import { EmailComponent } from "./emails";

// context
import { SendSmsEmailConext } from "../provider";

function SendNotificationPopUp(value) {
  return (
    <SendSmsEmailConext.Consumer>
      {({ type }) => {
        return type === "SMS" ? (
          <SmsComponent meetingId={value.meetingId} />
        ) : type === "Email" ? (
          <EmailComponent meetingId={value.meetingId} />
        ) : (
          <React.Fragment />
        );
      }}
    </SendSmsEmailConext.Consumer>
  );
}

export { SendNotificationPopUp };
